export var text = '_3fgAC';